// Set to true while Pool Shifts is being decommissioned (observation period).
// Flip to false to restore the UI; remove once backend removal is confirmed safe.
export const HIDE_POOL_SHIFTS = true



// WEBPACK FOOTER //
// ./src/constants/featureFlags.js